export default __webpack_public_path__ + "static/media/blog-img143.ef70551b.jpg";